import React, { useState } from "react";
import Modal from "react-modal";
import CreateMealForm from "./CreateMealForm";
import SearchNButtons from "../../common-components/SearchNButtons";

const MealFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  callFunction,
}) => {
  const [modals, setModal] = useState(false);

  return (
    <>
      <Modal
        isOpen={modals}
        onRequestClose={() => {
          setModal(false);
        }}
        contentLabel="Add Meal Modal"
        ariaHideApp={false}
      >
        <CreateMealForm
          closeModal={() => {
            setModal(false);
            callFunction();
          }}
          callFunction={callFunction}
        />
      </Modal>

      <SearchNButtons
        pageName={"meal"}
        btnText={"+ Add meal"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setModal(true)}
      />
    </>
  );
};

export default MealFilters;
